import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { milestones, currentMilestoneIndex } from '../../data/loanStatus';
const ease = [0.23, 1, 0.32, 1] as const;
export function LoanTimeline() {
  const current = milestones[currentMilestoneIndex];
  const pct = currentMilestoneIndex / (milestones.length - 1) * 100;
  return <div data-id="element-475" data-mp="rkbnqv30hhjk">
      {/* Desktop: horizontal */}
      <div className="hidden md:block" data-id="element-476" data-mp="rldb9z17rwi6">
        <div className="relative mx-[6px] h-1 rounded-full bg-ink-200" data-id="element-477" data-mp="ri7j2axagei8">
          <motion.div className="absolute inset-y-0 left-0 rounded-full bg-pulse-600" initial={{
          width: 0
        }} animate={{
          width: `${pct}%`
        }} transition={{
          duration: 0.9,
          ease,
          delay: 0.2
        }} data-id="element-478" data-mp="mmsanyi1vat7" />
        </div>
        <ol className="-mt-2 grid" style={{
        gridTemplateColumns: `repeat(${milestones.length}, minmax(0, 1fr))`
      }} data-id="element-479" data-mp="vkcar446f128">
          {milestones.map((m, i) => {
          const done = i < currentMilestoneIndex;
          const active = i === currentMilestoneIndex;
          return <li key={m.id} className={`${i === milestones.length - 1 ? 'text-right' : i === 0 ? '' : 'text-center'}`} aria-current={active ? 'step' : undefined} data-id="element-480" data-mp="u9ma6tnko244" data-mpi={i}>
                <span className={`flex ${i === milestones.length - 1 ? 'justify-end' : i === 0 ? '' : 'justify-center'}`} data-id="element-481" data-mp="13znncqee0049">
                  <span className={`relative grid h-3 w-3 place-items-center rounded-full ring-4 ring-white ${done ? 'bg-pulse-600' : active ? 'bg-pulse-600' : 'bg-ink-300'}`} data-id="element-482" data-mp="18y8qoyoxqzwx">
                    {active && <motion.span className="absolute inset-0 rounded-full bg-pulse-600" animate={{
                  scale: [1, 2.2],
                  opacity: [0.4, 0]
                }} transition={{
                  duration: 1.8,
                  repeat: Infinity,
                  ease: 'easeOut'
                }} aria-hidden data-id="element-483" data-mp="g9tdmhpd6ro8" />}
                  </span>
                </span>
                <p className={`mt-3 text-[13px] font-medium ${active ? 'text-ink-900' : done ? 'text-ink-700' : 'text-ink-400'}`} data-id="element-484" data-mp="1woux6ljakc4t">{m.label}</p>
                <p className="tabular mt-0.5 text-xs text-ink-400" data-id="element-485" data-mp="21mwg96gpwbga">{m.date}</p>
              </li>;
        })}
        </ol>
      </div>

      {/* Mobile: vertical, current expanded */}
      <ol className="space-y-0 md:hidden" data-id="element-486" data-mp="3sqxz4ron23dl">
        {milestones.map((m, i) => {
        const done = i < currentMilestoneIndex;
        const active = i === currentMilestoneIndex;
        return <li key={m.id} className="relative flex gap-4 pb-5 last:pb-0" aria-current={active ? 'step' : undefined} data-id="element-487" data-mp="6m42v258h984" data-mpi={i}>
              {i < milestones.length - 1 && <span className={`absolute left-[11px] top-6 h-[calc(100%-16px)] w-px ${done ? 'bg-pulse-400' : 'bg-ink-200'}`} aria-hidden data-id="element-488" data-mp="3a1hwnyte80uj" />}
              <span className={`relative z-10 grid h-6 w-6 shrink-0 place-items-center rounded-full ${done ? 'bg-pulse-600 text-white' : active ? 'bg-white ring-2 ring-pulse-600' : 'bg-white ring-1 ring-ink-300'}`} data-id="element-489" data-mp="3nty2t8hlcezo">
                {done && <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden data-id="element-490" data-mp="2vasicnkmy5mg" />}
                {active && <span className="h-2 w-2 rounded-full bg-pulse-600" aria-hidden data-id="element-491" data-mp="2raibz9sxld72" />}
              </span>
              <div className="flex-1 pt-0.5" data-id="element-492" data-mp="2h5icmva5kzn4">
                <div className="flex items-baseline justify-between gap-3" data-id="element-493" data-mp="2lxjq2kj24weq">
                  <p className={`text-[15px] font-medium ${active ? 'text-ink-900' : done ? 'text-ink-700' : 'text-ink-400'}`} data-id="element-494" data-mp="2lzmpfv63o1w4">{m.label}</p>
                  <span className="tabular text-xs text-ink-400" data-id="element-495" data-mp="2c777uyyptfbr">{m.date}</span>
                </div>
                {active && <p className="mt-1 text-sm leading-relaxed text-ink-500" data-id="element-496" data-mp="2zym9epio3sly">{m.detail}</p>}
              </div>
            </li>;
      })}
      </ol>

      <p className="mt-6 hidden rounded-2xl bg-ink-50 px-4 py-3 text-sm leading-relaxed text-ink-500 md:block" data-id="element-497" data-mp="2pzeye8zeoa20">
        <span className="font-medium text-ink-900" data-id="element-498" data-mp="2uy85njo3n4tq">{current.label}: </span>
        {current.detail}
      </p>
    </div>;
}